import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'semantic-ui-react'
import styled from 'styled-components'
import Price from './Price'
const DiscountDiv = styled.div`
  padding-bottom: 5px;
`

const ProductPrice = ({
  price,
  discount,
  originalPricePosition,
}) => (
  <Card.Description className="product-price">
    {originalPricePosition === 'top' ?
      <Price
        price={price}
        discount={discount}
      />
      :
      <Price
        price={price}
        discount={discount}
      >
        {discount ?
          <DiscountDiv>
            <Price.Discount bold size="huge" />
          </DiscountDiv>
          :
          ''
        }
        <Price.Original bold size={discount ? 'large' : 'huge'} />
      </Price>
    }
  </Card.Description>
)

ProductPrice.propTypes = {
  price: PropTypes.object,
  discount: PropTypes.object,
  originalPricePosition: PropTypes.oneOf(['top', 'bottom']),
}
ProductPrice.defaultProps = {
  price: {},
  discount: {},
  originalPricePosition: 'top',
}

export default ProductPrice



// WEBPACK FOOTER //
// ./src/cms/components/productCard/ProductPrice.js